import { map } from 'rxjs/operators';
import { Injector } from '@angular/core';
import { LegalEntitiesApi, LegalEntitiesApiClient } from '@sg/api/legal-entities-api';

import { SgEntityFetchAdapter } from '../components/entity-select-auto-complete';
import { validateArrayType } from './utils/validate-array';
import { LenderLegalEntity } from '../api-types';

type LegalEntitiesTypes = LegalEntitiesApi.BorrowerDto | LenderLegalEntity;

declare module '../components/entity-select-auto-complete/entity-select-fetch-store.service' {
  export interface SgEntitySelectEntityFetchMap {
    LegalEntitySimple: {
      entity: LegalEntitiesTypes;
      query: LegalEntitiesApi.SearchLegalEntitiesRequest;
    };
  }
}

export class LegalEntitySimpleApiToEntityFetcherLink implements SgEntityFetchAdapter<'LegalEntitySimple'> {
  readonly key: 'LegalEntitySimple' = 'LegalEntitySimple';
  readonly metadata: {
    idField: keyof LegalEntitiesTypes;
    labelField: keyof LegalEntitiesTypes;
    queryField?: { field: keyof LegalEntitiesApi.SearchLegalEntitiesRequest; isArray?: boolean };
  } = {
    idField: 'legalEntityId',
    labelField: 'code',
    queryField: { field: 'codes', isArray: true },
  };

  private readonly legalEntityApi: LegalEntitiesApiClient;

  constructor(injector: Injector) {
    this.legalEntityApi = injector.get(LegalEntitiesApiClient);
  }

  getEntity(ids: string[]) {
    const body: LegalEntitiesApi.SearchLegalEntitiesRequest = { ids: validateArrayType(ids) };
    return this.legalEntityApi
      .legalEntitiesControllerGetLegalEntitiesBySearchParams(
        { body, pageNumber: 1, orderBy: 'name', sortDirection: 'asc' },
        { observe: 'body' }
      )
      .pipe(map((results) => results.rows));
  }

  findEntities(query?: LegalEntitiesApi.SearchLegalEntitiesRequest, pageNumber?: number) {
    const body: LegalEntitiesApi.SearchLegalEntitiesRequest = { allowPartialCodeSearchForSingleCode: true };

    if (query) {
      Object.assign(body, query);
    }

    return this.legalEntityApi
      .legalEntitiesControllerGetLegalEntitiesBySearchParams(
        { body, pageSize: 10, pageNumber: pageNumber ?? 1, orderBy: 'name', sortDirection: 'asc' },
        { observe: 'body' }
      )
      .pipe(
        map((result) => {
          return {
            data: result.rows ? result.rows : [],
            infiniteScrollInfo: { currentPage: result.paging.pageNumber, totalPages: result.paging.totalPages },
          };
        })
      );
  }
}
